/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stealth_Access_SubmitInputs */



/**
* | output |
* | --- |
* | "Request access" |
*
* @param {Stealth_Access_SubmitInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const stealth_access_submit = /** @type {((inputs?: Stealth_Access_SubmitInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stealth_Access_SubmitInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Request access")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Begär åtkomst")
	return /** @type {LocalizedString} */ ("Be om tilgang")
});